import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ACHFundResponse | undefined,
  (requestParams?: vp.ACHFundRequest) => void,
  () => void,
  (requestParams: vp.ACHFundRequest) => Promise<vp.ACHFundResponse>,
];

function usePostACHFund({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.ACHFundRequest>();
  const [response, setResponse] = useState<vp.ACHFundResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ACHFundRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postACHFund(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.ACHFundRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },

    async (requestParams: vp.ACHFundRequest) => {
      return api.postACHFund(requestParams, source);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostACHFund);
